export var LiveSttResultStatus;
(function (LiveSttResultStatus) {
    /**
     * Result content is not final; possible for it to change.
     */
    LiveSttResultStatus["Partial"] = "partial";
    /**
     * Result content is final; will not change; unless it is removed.
     */
    LiveSttResultStatus["Final"] = "final";
    /**
     * Result content has been removed.
     */
    LiveSttResultStatus["Removed"] = "removed";
})(LiveSttResultStatus || (LiveSttResultStatus = {}));
